import { GDPR_PREFERENCES_COOKIE } from '@wkda/gdprlib';
import {
  cmsDuck,
  footerDuck,
  dsbWidgetDuck,
  dsbBookingWidgetDuck,
  gdprCookieBannerDuck,
} from '../duck';

export const fetch = () =>
  function* ({ cookies }) {
    yield [
      gdprCookieBannerDuck.set({
        [GDPR_PREFERENCES_COOKIE]: cookies.get(GDPR_PREFERENCES_COOKIE),
      }),
      cmsDuck.tryLoad(),
      footerDuck.tryLoad(),
      gdprCookieBannerDuck.tryLoad(),
    ];
  };

export const loadDsbMainWidget = () =>
  function* () {
    yield [dsbWidgetDuck.tryLoad(), dsbBookingWidgetDuck.tryLoad()];
  };
